export default {"src":"/_next/static/media/profile-details.e652b5d4.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};